import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase';
import 'babel-polyfill';

import FirebaseConfig from './app/config/firebase';
import { configureStore } from './app/store';
import Root from './app';
import registerServiceWorker from './registerServiceWorker';
import './index.css';

firebase.initializeApp(FirebaseConfig);

const store = configureStore();

ReactDOM.render(
  <Root store={ store } />,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js